import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  getCarePlanvalue: '',
};

const carePlanSlice = createSlice({
  name: 'carePlanSlice',
  initialState,
  reducers: {
    carePlanLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    getCarePlanSlice: (state, { payload }) => {
      state.getCarePlanvalue = payload;
    },
  },
});

const { actions, reducer } = carePlanSlice;

export const { carePlanLoading, getCarePlanSlice } = actions;

export default reducer;
